/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: DevDataOverlay.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/9 @ 1738
 * ---
 * Description:
 */

import {
  Button,
  Card,
  Classes,
  Divider,
  Intent,
  Overlay
}                             from '@blueprintjs/core';
import classNames             from 'classnames';
import React, { useCallback } from 'react';
import { currentThemeIsDark } from '../../common/utils';
import { CenterBothAxes }     from '../common/layout/CenterBothAxes';
import { Editor }             from '../../store/observables/Editor';
import { MleToaster }         from '../../common/toast';

interface DevDataOverlayProps {
  editor: Editor;
  onClose: () => any;
  isOpen: boolean;
}

export const DevDataOverlay = (props: DevDataOverlayProps) => {
  const handleCopyAll = useCallback(() => {
    navigator.clipboard.writeText(props.editor.getSelectedShape().pamelaShape__nonObservable.toJSON());
    MleToaster.getInstance().show({
      message: 'Contenuto copiato negli appunti',
      intent: 'success',
      icon: 'tick'
    });
  }, [props.editor.getSelectedShape()]);

  return <Overlay
    onClose={ props.onClose }
    usePortal enforceFocus canEscapeKeyClose
    isOpen={ props.isOpen }
    className={ classNames(Classes.OVERLAY_SCROLL_CONTAINER,
      { 'bp4-dark': currentThemeIsDark() }) }
    canOutsideClickClose
  >
    <CenterBothAxes>
      <Card
        className="mle-center-both-axes-child mx-auto min-w-max overflow-y-hidden">
        <h5 className="bp4-heading">Dettagli sviluppatori <div
          className="font-light">Componente corrente</div></h5>
        <Divider className="my-4"/>
        <div className="px-2">
          <div className="bp4-running-text h-96 w-96">
            <code>mleId: { props.editor.getSelectedShape()?.pamelaShape__nonObservable.id() }</code>
            <div/>
            <code>name: { props.editor.getSelectedShape()?.name }</code>
            {
              props.editor && props.editor.hasSelection() &&
              <pre className={ 'w-85 overflow-auto h-80' }>
              { JSON.stringify(JSON.parse(props.editor.getSelectedShape()?.pamelaShape__nonObservable.toJSON() as string),
                null,
                2) }
            </pre>
            }
          </div>
          <div className="mle-form-submit mt-2 space-x-3">
            <Button onClick={ handleCopyAll }
                    intent={ Intent.PRIMARY }>Copia</Button>
            <Button onClick={ props.onClose }>Chiudi</Button>
          </div>
        </div>
      </Card>
    </CenterBothAxes>
  </Overlay>;
};
